module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/cover"
    }
  }, [_vm._v("SWORDS AND DEVILTRY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section1#a1"
    }
  }, [_vm._v("I Induction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section1#a2"
    }
  }, [_vm._v("II The Snow Women")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section1#a3"
    }
  }, [_vm._v("III The Unholy Grail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section1#a4"
    }
  }, [_vm._v("IV Ill Met in Lankhmar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SWORDS AGAINST DEATH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I – The Circle Curse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II – The Jewels in the Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III – Thieves’ House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV – The Bleak Store")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V – The Howling Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI – The Sunken Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII – The Seven Black Priests")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII – Claws from the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX – The Prince of Pain-ease")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/section11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X – Bazaar of the Bizarre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SWORDS IN THE MIST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/section2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I – The Cloud of Hate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/section3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II – Lean Times in Lankhmar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/section4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III – Their Mistress, The Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/section5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV – When the Sea-King’s Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/section6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V – The Wrong Branch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/section7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI – Adept’s Gambit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("Swords Against Wizardry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 69
// module chunks = 0